/**
 * Created by Bart Decorte
 * Date: 12/11/2018
 * Time: 15:39
 */
import Page from '../Page';
import DirtyUnloadNotifier from '../../utils/DirtyUnloadNotifier';

class UsersManipulate extends Page {
  constructor() {
    super();
    this.bindListeners();
    new DirtyUnloadNotifier('.js-dirty-unload-notify');
  }

  bindListeners() {
    let $pageHeading = $('.js-page-header');
    $pageHeading.find('.js-btn-save').on('click', (ev) => {
      return this.lHeadingBtnSaveClick(ev);
    });
    $('.js-module-select-all').on('click', (ev) => {
      this.changeAllSiteModulesRights(ev, true);
    });
    $('.js-module-deselect-all').on('click', (ev) => {
      this.changeAllSiteModulesRights(ev, false);
    });
  }

  lHeadingBtnSaveClick(ev) {
    ev.preventDefault();
    $('.js-user-actions .js-btn-save')
      .get(0)
      .click();
    return false;
  }

  changeAllSiteModulesRights(ev, status) {
    const websiteId = ev.currentTarget.dataset.websiteId;
    const $switches = $(`.js-module-switch[data-website-id="${websiteId}"`);

    $switches.toArray().forEach((moduleSwitch) => {
      $(moduleSwitch).prop('checked', status);
    });
  }
}

export default UsersManipulate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Users/UsersManipulate.js